var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('div',{staticClass:"cl"},[_c('div',{staticClass:"fl"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" UNU TECHNOLOGY LIMITED. All rights reserved.")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fr"},[_c('span',[_vm._v("(852) 2616 0676")]),_c('span',[_vm._v("info@unutravel.com")])])
}]

export { render, staticRenderFns }